var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.583496 11.25L7.00016 0.166656L13.4168 11.25H0.583496ZM2.596 10.0833H11.4043L7.00016 2.49999L2.596 10.0833ZM7.00016 9.49999C7.16544 9.49999 7.30398 9.44409 7.41579 9.33228C7.52759 9.22048 7.5835 9.08193 7.5835 8.91666C7.5835 8.75138 7.52759 8.61284 7.41579 8.50103C7.30398 8.38923 7.16544 8.33332 7.00016 8.33332C6.83488 8.33332 6.69634 8.38923 6.58454 8.50103C6.47273 8.61284 6.41683 8.75138 6.41683 8.91666C6.41683 9.08193 6.47273 9.22048 6.58454 9.33228C6.69634 9.44409 6.83488 9.49999 7.00016 9.49999ZM6.41683 7.74999H7.5835V4.83332H6.41683V7.74999Z",
    fill: "#E63C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.84ecd333.svg";
export { ForwardRef as ReactComponent };